import { render, staticRenderFns } from "./404.vue?vue&type=template&id=6fdf6882&"
import script from "./404.vue?vue&type=script&lang=js&"
export * from "./404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fdf6882')) {
      api.createRecord('6fdf6882', component.options)
    } else {
      api.reload('6fdf6882', component.options)
    }
    module.hot.accept("./404.vue?vue&type=template&id=6fdf6882&", function () {
      api.rerender('6fdf6882', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/core/Exception/404.vue"
export default component.exports